import { createDom, createImgBtn, hasClass, addClass } from 'xgplayer/src/utils/util'
import RequestFullIcon from '../assets/requestFull.svg'
import ExitFullIcon from '../assets/exitFull.svg'
import '../style/controls/fullscreen.scss'
let isFromHoleFullscreen = false

/** 全全屏的esc无法监听，为防止esc导致样式失效，各自添加一次xgplayer-is-cssfullscreen 样式 */
function windowScaleEvent(player) {
  if (isFromHoleFullscreen) return

  setTimeout(() => {
    addClass(player.root, 'xgplayer-is-cssfullscreen')
    player?.emit('beforeCssFullscreenEnter')
    player?.userGestureTrigEvent('cssFullscreenBtnClick')
    isFromHoleFullscreen = false
  }, 300)
}
let s_fullscreen = function() {
  let player = this
  let fullscreenBtn = player.config.fullscreenBtn ? player.config.fullscreenBtn : {}
  let btn

  if (fullscreenBtn.type === 'img') {
    btn = createImgBtn('fullscreen', fullscreenBtn.url.request, fullscreenBtn.width, fullscreenBtn.height)
  } else {
    btn = createDom(
      'xg-fullscreen',
      `<xg-icon class="xgplayer-icon">
                                             <div class="xgplayer-icon-requestfull full-icon">${RequestFullIcon}</div>
                                             <div class="xgplayer-icon-exitfull full-icon">${ExitFullIcon}</div>
                                           </xg-icon>`,
      {},
      'xgplayer-fullscreen'
    )
  }

  let tipsText = {}
  tipsText.requestfull = player.lang.FULLSCREEN_TIPS
  tipsText.exitfull = player.lang.EXITFULLSCREEN_TIPS
  let tips = createDom(
    'xg-tips',
    `<span class="xgplayer-tip-requestfull">${tipsText.requestfull}</span>
      <span class="xgplayer-tip-exitfull">${tipsText.exitfull}</span>`,
    {},
    'xgplayer-tips tips-with-corn'
  )
  btn.appendChild(tips)
  player.once('ready', () => {
    window.onresize = () => windowScaleEvent(player)
    if (player.controls) {
      player.controls.appendChild(btn)
    }
  })
  ;['click', 'touchend'].forEach(item => {
    btn.addEventListener(item, function(e) {
      e.preventDefault()
      e.stopPropagation()

      // 标记本次【变大全屏】是否基于【样式全屏】。 如果是本身已经样式全屏，则有缩小时需要额外处理，因原视频的宽高会有问题。
      if (hasClass(player.root, 'xgplayer-is-cssfullscreen')) {
        isFromHoleFullscreen = true
      }

      player.userGestureTrigEvent('fullscreenBtnClick')

      /** 【样式全屏】情况下可继续转【更大屏全屏】，但此时如果从大全屏缩小，原视频的宽高有问题。 因此如果本次大全屏是基于样式全屏，则复原视频后切回样式全屏。 以下为手动恢复到样式全屏。 大全屏缩小大概需要300ms */
      if (isFromHoleFullscreen) {
        setTimeout(() => {
          player.emit('beforeCssFullscreenEnter')
          player.userGestureTrigEvent('cssFullscreenBtnClick')
          addClass(player.root, 'xgplayer-is-cssfullscreen')
          isFromHoleFullscreen = false
        }, 300)
      }
    })
  })
}

export default {
  name: 's_fullscreen',
  method: s_fullscreen
}
